<template>
  <el-dialog
    append-to-body
    title="Yeni Talep"
    :visible.sync="Modal"
    width="60%">
    <a @click="$emit('Kapat',true)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-alert
      :closable="false"
      title="Yapıfen taleplerinde müşteriye aşağıdaki içeriği tebliğ ediniz!"
      description="Talebiniz iş ortağımız olan JetUsta tarafına iletiyorum. Cep telefonu ve ilettiğiniz bilgiler ile JetUsta mobil uygulamasına kaydınız oluşturulacaktır. JetUsta uygulaması üzerinden iş takibi yapabileceksiniz. Verdiğiniz bilgiler ile JetUsta'ya kayıt yapmamı onaylıyormusunuz ?"
      type="error">
    </el-alert>
    <hr>
    <el-form :model="Form" @submit.prevent.native="Kaydet" :rules="FormHata" ref="Form">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="Hizmet" prop="Hizmet_id">
            <el-select v-model="Form.Hizmet_id" filterable>
              <el-option-group
                v-for="group in Hizmetler"
                :key="group.Tanim"
                :label="group.Tanim">
                <el-option
                  v-for="item in group.Alt"
                  :key="item.id"
                  :label="item.Tanim"
                  :value="item.id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Ad Soyad" prop="AdSoyad">
            <el-input v-model="Form.AdSoyad"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Cep Telefonu" prop="Telefon">
            <el-input v-model="Form.Telefon" v-mask="'### ### ## ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="YP Abone No" prop="AboneNo">
            <el-input v-model="Form.AboneNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Adres Tanım" prop="AdresBaslik">
            <el-input v-model="Form.AdresBaslik"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="Adres Tarifi" prop="Adres">
            <el-input v-model="Form.Adres"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Talep edilen hizmet detaylı açıklaması" prop="Aciklama">
            <el-input type="textarea" v-model="Form.Aciklama"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Randevu Tarihi" prop="Randevu">
            <el-date-picker
              :clearable="false"
              v-model="Form.Randevu"
              type="datetime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Kampanya" prop="Kampanya_id">
            <el-select v-model="Form.Kampanya_id" filterable clearable>
              <el-option
                v-for="item in Kampanyalar"
                :key="item.id"
                :label="item.Adi"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="Kaydet">Kaydet</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['Data', 'AboneNo','AdSoyad','Adres','Hizmet_id'],
  data() {
    return {
      Modal: true,
      Hizmetler: null,
      Form: {
        AdSoyad: '',
        Telefon: '',
        AboneNo: '',
        Hizmet_id: null,
        Kampanya_id: null,
        AdresBaslik: 'Ev Adresim',
        Aciklama: '',
        Randevu: '',
        Adres: ''
      },
      FormHata: {
        AdSoyad: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Hizmet_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        AdresBaslik: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Adres: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      }
    }
  },
  methods: {
    Kaydet() {

      this.$refs['Form'].validate((valid) => {
        if (valid) {

          this.lo = true;
          this.$store.dispatch("Post", {
            Data: this.Form,
            path: '_ju/siparis'
          })
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.$message.success("Talep kayıt edilmiştir.");
                this.$emit('Kapat', true);
              } else {
                this.$message.warning(response.Mesaj);
              }
            })
        }
      })
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Post", {path: '_ju/spesiyal/hizmetler'})
        .then(response => {
          this.lo = false;
          this.Hizmetler = response.Hizmetler
          this.Kampanyalar = response.Kampanyalar
        });
    }
  },
  created() {
    this.SayfaYukle();
    if (this.AboneNo) this.Form.AboneNo = this.AboneNo
    if (this.AdSoyad) this.Form.AdSoyad = this.AdSoyad
    if (this.Adres) this.Form.Adres = this.Adres
    if (this.Hizmet_id) this.Form.Hizmet_id = this.Hizmet_id
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/JetUsta/Comp/juYeniTalep.vue